var _defs, _path, _path2, _polygon, _rect, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _polygon5, _rect4, _polygon6, _rect5, _polygon7, _rect6, _rect7, _rect8, _polygon8, _rect9, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _path3, _polygon12, _rect0, _polygon13, _polygon14, _polygon15, _rect1, _rect10, _polygon16, _rect11, _polygon17, _rect12, _polygon18, _rect13, _rect14, _rect15, _polygon19, _rect16, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path4, _path5, _path6, _path7, _polygon25, _polygon26, _path8, _path9, _rect17, _polygon27, _polygon28, _polygon29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoblanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.99 140.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcfcfc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGINEM-logo-blanco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.58,63.22c5-15.09-5.41-44.34-51.18-39.65,74.17-32.25,76.71,15.56,51.18,39.65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.76,47.1c-5,15.09,5.41,44.34,51.18,39.65C12.77,119,10.23,71.19,35.76,47.1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30 41.17 27.27 41.17 27.27 41.62 25.19 41.62 25.19 40.52 23.29 40.52 23.29 43.53 23.56 43.53 23.56 43.99 25.45 43.99 25.45 43.53 27.54 43.53 27.54 42.85 30 42.85 30 41.17"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.03,
    y: 35.03,
    width: 1.9,
    height: 1.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.12 35.37 25.23 35.37 25.23 36.81 23.74 36.81 23.74 38.16 26.1 38.16 26.1 37.27 27.12 37.27 27.12 35.37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.13 44.04 21.13 42.46 18.63 42.46 18.63 43.1 18.63 44.04 18.63 44.2 17 44.2 17 45.78 18.74 45.78 18.74 47.35 20.68 47.35 20.68 45.41 20.02 45.41 20.02 44.04 21.13 44.04"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.29 53.4 17.25 53.4 16.49 53.4 16.29 53.4 16.29 52 16.91 52 16.91 50.88 15.69 50.88 13.55 50.88 11.92 50.88 11.92 52.81 15.03 52.81 15.03 55.87 15.44 55.87 16.29 55.87 17.25 55.87 17.25 54.82 18.29 54.82 18.29 53.4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.2,
    y: 51.93,
    width: 1.82,
    height: 1.82
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.05,
    y: 57.55,
    width: 1.92,
    height: 1.92
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.77 61.98 14.6 61.98 13.85 61.98 12.68 61.98 12.68 64.94 14.6 64.94 14.6 63.85 15.77 63.85 15.77 61.98"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.82,
    y: 59.33,
    width: 2.93,
    height: 2.93
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.69 69.87 6.69 68.01 4.73 68.01 4.73 70.94 5.94 70.94 5.94 72.34 7.9 72.34 7.9 69.87 6.69 69.87"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.14,
    y: 79.84,
    width: 1.95,
    height: 2.98
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.24 84.47 8.24 82.98 6.29 82.98 6.29 85.96 7.57 85.96 8.24 85.96 9.53 85.96 9.53 84.47 8.24 84.47"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.88,
    y: 63.76,
    width: 1.83,
    height: 1.83
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.81,
    y: 73.28,
    width: 2.84,
    height: 1.83
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.61,
    y: 84.2,
    width: 2.57,
    height: 3.49
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.15 75.78 6.13 75.78 6.13 77.03 3.63 77.03 3.63 80.52 6.41 80.52 6.41 79.27 8.15 79.27 8.15 75.78"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.54,
    y: 66.57,
    width: 1.94,
    height: 2.63
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.03 88.24 7.03 86.59 4.38 86.59 4.38 89.24 6.35 89.24 6.35 90.6 8.78 90.6 8.78 92.2 10.8 92.2 10.8 90.6 10.8 89.84 10.8 88.24 7.03 88.24"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.74 103.92 21.74 102.31 21.74 101.33 19.96 101.33 19.96 101.29 19.96 100.63 19.96 99.83 17.27 99.83 17.27 101.29 18.05 101.29 18.05 104.57 19.37 104.57 19.88 104.57 19.88 105.56 20.3 105.56 21.74 105.56 23.83 105.56 23.83 103.92 21.74 103.92"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.49 103.79 32.49 100.66 28.59 100.66 28.59 101.72 24.89 101.72 24.89 106.75 25.64 106.75 29.69 106.75 30.45 106.75 30.45 105.44 29.69 105.44 29.69 103.79 32.49 103.79"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.17 106.24 34.95 106.24 34.02 106.24 32.29 106.24 32.29 107.6 29.38 107.6 29.38 109.57 34.95 109.57 34.95 108.62 34.95 108.36 38.17 108.36 38.17 106.24"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.42 95.77 19.42 95.42 19.42 94.91 19.42 94 17.39 94 17.39 95.06 15.94 95.06 15.94 93.58 14.57 93.58 14.57 92.26 12.02 92.26 12.02 94.28 13.44 94.28 13.44 95.1 9.42 95.1 9.42 97.13 11.33 97.13 11.33 98.64 15.94 98.64 15.94 97.13 15.94 96.62 15.94 96.48 17.99 96.48 17.99 97.23 18.98 97.23 19.42 97.23 20.91 97.23 20.91 95.77 19.42 95.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.83,83.93l-17.59.84,4.43,3.73h0a108.15,108.15,0,0,1-20.11,9.67c-12.24,4.36-23,6.56-32,6.56H44.36a48.93,48.93,0,0,1-5.69-.46l0,1.43h1.95v2.81H38.78l.06,2a53.08,53.08,0,0,0,6,.45l1.32,0c9,0,19.2-1.59,30.76-5.28A141.15,141.15,0,0,0,99.4,96.17l4.54-2.37L108,97.24Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.67 69.76 125.41 69.76 125.41 69.31 127.48 69.31 127.48 70.41 129.38 70.41 129.38 67.4 129.11 67.4 129.11 66.95 127.22 66.95 127.22 67.4 125.13 67.4 125.13 68.08 122.67 68.08 122.67 69.76"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.74,
    y: 74.01,
    width: 1.9,
    height: 1.9
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "125.55 75.57 127.44 75.57 127.44 74.13 128.94 74.13 128.94 72.77 126.57 72.77 126.57 73.67 125.55 73.67 125.55 75.57"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.54 66.89 131.54 68.48 134.04 68.48 134.04 67.83 134.04 66.89 134.04 66.73 135.67 66.73 135.67 65.15 133.93 65.15 133.93 63.59 131.99 63.59 131.99 65.52 132.65 65.52 132.65 66.89 131.54 66.89"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.38 57.53 135.42 57.53 136.18 57.53 136.38 57.53 136.38 58.94 135.76 58.94 135.76 60.06 136.98 60.06 139.12 60.06 140.75 60.06 140.75 58.13 137.64 58.13 137.64 55.07 137.23 55.07 136.38 55.07 135.42 55.07 135.42 56.12 134.38 56.12 134.38 57.53"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.65,
    y: 57.18,
    width: 1.82,
    height: 1.82
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.7,
    y: 51.47,
    width: 1.92,
    height: 1.92
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.9 48.95 138.07 48.95 138.82 48.95 139.99 48.95 139.99 46 138.07 46 138.07 47.09 136.9 47.09 136.9 48.95"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.93,
    y: 48.68,
    width: 2.93,
    height: 2.93
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.98 41.07 145.98 42.93 147.94 42.93 147.94 40 146.73 40 146.73 38.59 144.77 38.59 144.77 41.07 145.98 41.07"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.57,
    y: 28.12,
    width: 1.95,
    height: 2.98
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.43 26.46 144.43 27.95 146.38 27.95 146.38 24.98 145.1 24.98 144.43 24.98 143.14 24.98 143.14 26.46 144.43 26.46"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.96,
    y: 45.34,
    width: 1.83,
    height: 1.83
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.02,
    y: 35.83,
    width: 2.84,
    height: 1.83
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.5,
    y: 23.24,
    width: 2.57,
    height: 3.49
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.52 35.15 146.54 35.15 146.54 33.91 149.04 33.91 149.04 30.41 146.26 30.41 146.26 31.66 144.52 31.66 144.52 35.15"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.18,
    y: 41.74,
    width: 1.94,
    height: 2.63
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.64 22.69 145.64 24.35 148.29 24.35 148.29 21.7 146.32 21.7 146.32 20.33 143.89 20.33 143.89 18.74 141.87 18.74 141.87 20.33 141.87 21.1 141.87 22.69 145.64 22.69"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "130.93 7.02 130.93 8.62 130.93 9.61 132.71 9.61 132.71 9.64 132.71 10.31 132.71 11.11 135.4 11.11 135.4 9.64 134.63 9.64 134.63 6.36 133.3 6.36 132.79 6.36 132.79 5.38 132.37 5.38 130.93 5.38 128.84 5.38 128.84 7.02 130.93 7.02"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "120.18 7.15 120.18 10.28 124.08 10.28 124.08 9.22 127.78 9.22 127.78 4.18 127.03 4.18 122.98 4.18 122.22 4.18 122.22 5.49 122.98 5.49 122.98 7.15 120.18 7.15"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.5 4.7 117.72 4.7 118.66 4.7 120.38 4.7 120.38 3.33 123.29 3.33 123.29 1.37 117.72 1.37 117.72 2.31 117.72 2.58 114.5 2.58 114.5 4.7"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "133.25 15.16 133.25 15.52 133.25 16.03 133.25 16.94 135.28 16.94 135.28 15.88 136.73 15.88 136.73 17.35 138.09 17.35 138.09 18.68 140.65 18.68 140.65 16.66 139.23 16.66 139.23 15.83 143.25 15.83 143.25 13.81 141.34 13.81 141.34 12.29 136.73 12.29 136.73 13.81 136.73 14.32 136.73 14.46 134.68 14.46 134.68 13.7 133.69 13.7 133.25 13.7 131.76 13.7 131.76 15.16 133.25 15.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.84,27l17.59-.83L55,22.43h0a108.11,108.11,0,0,1,20.11-9.66c12.24-4.36,23-6.56,32-6.56h1.18a44.91,44.91,0,0,1,5.69.46l0-1.44H112V2.44h1.88l-.06-2a58.16,58.16,0,0,0-6-.45H106.5c-9,0-19.2,1.59-30.76,5.27a141.19,141.19,0,0,0-22.47,9.5l-4.54,2.37L44.65,13.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.55,82.25l.17-.1.3-1.06s.23-.91.57-1.06S82,79.19,82,79.19c.68-.91-.12-1.25-.12-1.25a.58.58,0,0,1-.72-.26c-.3-.46.3-.61.72-1.07a.93.93,0,0,0,.12-1l.56-.53s-1,.19-.91,0a2.87,2.87,0,0,0,.27-.53c-1.18.76-5,.83-5,.83A18.24,18.24,0,0,1,74.43,75c-.19-.15-.79.23-1.21.31a1,1,0,0,1-1-.5c-.23-.3.15-.6.15-.6l-.45.26a5.81,5.81,0,0,1-1.1-.26,8.11,8.11,0,0,0-1.71,0L68,74.42a3.41,3.41,0,0,1-.53-.46c-.15-.19-1.06-.57-1.29-.76-.49-1-.84-.68-.84-.68a7.24,7.24,0,0,1-3.22-.11c-1-1-2.23-1-2.92-1.33s-2.5,1-2.5,1A16.19,16.19,0,0,1,55,72.9a5.66,5.66,0,0,1-1.41-.53L53,71.8l-.45-.45a8.27,8.27,0,0,1-.68-.88,8.64,8.64,0,0,0-.69-.79L51,69.15a3.76,3.76,0,0,1-.65.07,3.92,3.92,0,0,1-1-.34,7.83,7.83,0,0,0-.12-1.14l-1-.56s0-.35,0-.46.68.65.68.65l.49,0s1.41-.12,1.67-.12a6.63,6.63,0,0,1,1.4.72s.23.23.46.42,1.33,0,1.33,0l1.06.53.15.34,1,.46s.11-.08.94,0,1-.08,1.07-.49-.95-.42-.95-.42l-1-.15L55,67.78l-.34-.38-.72.12-1.1-.72c-.53-.46-1.82-.08-1.82-.08l-.91.08s-.79.15-1,.15a3.33,3.33,0,0,1-.8-.34L48,66.3l-.49-.11-.91-.76-.19-.38-.68-.19a2.17,2.17,0,0,1-.35-.57c-.11-.3.42-.75.42-.75.12-.72,3-.5,3.45-.46s.27.76.46,1.14a1.76,1.76,0,0,0,1.06.68c.26.08.79-.34.79-.34l-.72-.15s-.79-.27-.87-.8-.08-.49.68-.53,1-.95,1-.95c-.27-.94.94-.94.94-1.21a4.06,4.06,0,0,1,.57-1.1l.65-1A1.21,1.21,0,0,0,55.33,58a3.88,3.88,0,0,1,1-.49s.53.53.91.11a.53.53,0,0,0,0-.76A1.7,1.7,0,0,1,55.63,56c-.42-.45.91-1.4,1.18-1.36s1.93-.19,2,.07.64.65.64.65.19-.12.27.34,1.17.19,1.17.19l.42-.53-.68-.53a2.13,2.13,0,0,0-.54-.84,1.39,1.39,0,0,1-1.21-.34l-.11-.53-.84-.3s-.34-.08-.22-.23,0-.87-.12-.87l-1,.07-.27-.19c-.49.12-1.55-.53-1.55-.53l0-.22A4.43,4.43,0,0,0,55.4,49a7.14,7.14,0,0,1,.76-.72,11.88,11.88,0,0,0,1-.95l-.23-.53c.83.3,1-.34,1-.34L57.18,46A22.8,22.8,0,0,1,55,44.62c-.46-.38-.15-1.06-.15-1.06s.64-.65.94-.91a4.55,4.55,0,0,1,.72-.49l.76.9a.59.59,0,0,0,.72.12,2.41,2.41,0,0,1,2,1.25,3.58,3.58,0,0,1,0,2.09l.69,1.17.3,0,.72,1.06.76-.26.49.07a.58.58,0,0,0,.49.72.5.5,0,0,0,.69-.45s-.31-.42,0-.72,0-.84,0-.84l-.31-.75s.19-.61.38-.61.57-.38.57-.38l.57-.38,0-.6c1.52,1,.91-.73.91-.73l1.4-.15.49-.79-.57-1.1a1.53,1.53,0,0,1-.56-.38,6.08,6.08,0,0,1-.61-1.82l-.57-.34-.64.45-.53,0-.08.15-.38.08-.72-.38-.76.64s-2.2,1-3,1.48-2.92-.87-2.92-.87a1.87,1.87,0,0,0-1.44-.3.9.9,0,0,0-.57,1.25.75.75,0,0,1-.27.76s-.11.37-.72.37-.42.65-.42.65l.12.91-.61.57-.19.53A14.17,14.17,0,0,1,51,46a5.83,5.83,0,0,1-1.32,0,1.25,1.25,0,0,0-.84-.3c-.45,0-.49-.3-.49-.3a1.67,1.67,0,0,0-.15-.76c-.19-.49.76-1,1.1-.91s.79-.38.6-1,.53-.45.53-.45l.5-.38-1.18-.5a5.62,5.62,0,0,1-1.55,1c-.61.15-.42-.49-.65-.75s.15-.76.15-.76l1.14-1-.21-.17c-.05-.62,2.28-2.56,2.28-2.56a4.7,4.7,0,0,0-3.36,1.63c-5.75,7-8.19,15.87-5.83,24.34,0,0,1.62,7.13,11.63,9.67,0,0,1,.56,1.52.41a4,4,0,0,0,1,.27c.61.07.5.76.8,1.06s.08,1,.08,1,.18.88.64.95a.61.61,0,0,1,.49.53l.57.23a2.13,2.13,0,0,0,.72.65c.38.15,1.4.41,1.4.41s.72,0,.72.27,1,.53,1.14.53l.76,0s1.48.27,1.63.57a1.6,1.6,0,0,0,.64.53l2.35.68s.31.19.57.31a8.09,8.09,0,0,0,1.94.41,2.57,2.57,0,0,0,1.89.5s1.33.87,1.82.75a1.87,1.87,0,0,1,1.29.19c.38.19,1.1-.19,1.1-.19l1.25-.07s.65-.59.82-.47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.46,48.31c-4.32-15.49-22.48-24-40.55-18.92a8.65,8.65,0,0,0,2.19.48l-.53.38a36.18,36.18,0,0,0,4.17-.53l1.59.46,1.14.6,2.72.31a4.65,4.65,0,0,0,2.13,4.7l-5.08.6-.08,1.22.23.6a1.43,1.43,0,0,1,1.29,1.37A6.28,6.28,0,0,1,78.6,41l.15.68,2.81.46s-.08-.31.53-.46.61-1.67.15-2.05A3.31,3.31,0,0,0,81,39.12l-.45-.76,1.06-.6,2.2.91s2.5.91.68,3.56L83.15,43l-.23,1-.3,1.6-.91.6S80,45.49,79.82,45s-1.37-.31-1.37-.31l.3.38s2,.68,1.82,2l-.75.23-.34,0-1.1.11.37.38,1-.22L81,47.39s3.49-.08,3,1.36-1.21,1.67-1.21,1.67-.76.53-.38,1.14a3.11,3.11,0,0,0,2.28,1.21s0-1,1.13-.83l-.23.53,1,.53a2.33,2.33,0,0,0-.45,1.14c0,.53.3,1.28-.38,2l.45,1s-1.59.38-1.36,1.37l.22,1-.45,1.06a4,4,0,0,1,1.06,2.13l1.59.45-.23.53,1.07.31.6.53.53-.61,1.6.15.53.76,1.51.3.31-.76,1.21-.68,1.06.53,1.36-1.44,1.75-.53L98.85,61l1-.53,1.37.61s.22-1.52,1-1.37,1.29-.07,1.29,2.43l2.43.23.61,1.44.6.15-.23,1.59-.6.91.76.84-.31.6s2,.53,3-.91c0,0,3.34-4.85-.3-18.71m-10.92-3.2L97,46v.91a12.25,12.25,0,0,1-2.2,1c-.23-.08-1.37,1-1.37,1l-1.82-.68-.53,1-.76.45c-.37-.3-.45.61-.45.61L88.31,51l-1.37-.46s-.22-.45-.75-1.67,1.13-2.12,1.13-2.12l.76-.68c1-.46.3-.76.3-.76.46-1.37,1.6-.91,2.35-.91a7.73,7.73,0,0,0,1.9-.38l.68-1.29,2,.08.53-.61,2.12-.3.84,1.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.81,45l1.82-.53-.15.46s.6.22,0,.53-.84.45-1.67-.46"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.08 35.26 71.02 36.17 72.69 36.47 73.37 35.48 71.93 35.94 72.08 35.26"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 122.14 3.18 122.14 3.18 137.72 13.18 137.72 13.18 140.06 0 140.06 0 122.14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.3,121.88a13.67,13.67,0,0,1,8.57,2.63,8,8,0,0,1,3.43,6.59,7.91,7.91,0,0,1-3.46,6.56,14.1,14.1,0,0,1-8.71,2.6,13.25,13.25,0,0,1-8.37-2.6,7.92,7.92,0,0,1-3.34-6.51,8.08,8.08,0,0,1,3.37-6.64,13.42,13.42,0,0,1,8.51-2.63m.13,2.44a9.89,9.89,0,0,0-6.27,1.92,6,6,0,0,0-2.45,4.91A5.89,5.89,0,0,0,23.17,136a9.72,9.72,0,0,0,6.16,1.92,9.71,9.71,0,0,0,6.21-2A6,6,0,0,0,38,131.05a5.89,5.89,0,0,0-2.48-4.79,9.67,9.67,0,0,0-6.11-1.94"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.65,131.23h7.46v7.59A24.49,24.49,0,0,1,59,140.26c-3.68,0-6.62-.86-8.82-2.6a7.86,7.86,0,0,1-3.3-6.4,8.14,8.14,0,0,1,3.42-6.68,13.51,13.51,0,0,1,8.57-2.67,19.32,19.32,0,0,1,3.56.32,34.11,34.11,0,0,1,4.26,1.2v2.62a18.45,18.45,0,0,0-7.88-1.86,9.54,9.54,0,0,0-6.14,2,6.16,6.16,0,0,0,0,9.9A10.2,10.2,0,0,0,59.06,138a18.24,18.24,0,0,0,4.57-.71l.3-.07v-3.74H59.65Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.23,
    y: 122.14,
    width: 3.18,
    height: 17.92
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.42 122.14 105.44 122.14 105.44 140.06 102.71 140.06 87.86 126.26 87.86 140.06 84.87 140.06 84.87 122.14 87.44 122.14 102.42 136.05 102.42 122.14"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.64 122.14 125.23 122.14 125.23 124.42 115.82 124.42 115.82 129.88 124.91 129.88 124.91 132.18 115.82 132.18 115.82 137.75 125.53 137.75 125.53 140.03 112.64 140.03 112.64 122.14"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.02 122.14 151.99 122.14 151.99 140.06 148.8 140.06 148.8 126.11 141.97 133.04 141.38 133.04 134.47 126.11 134.47 140.06 131.29 140.06 131.29 122.14 134.31 122.14 141.68 129.5 149.02 122.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblanco);
export default __webpack_public_path__ + "static/media/logoblanco.44fde4597a4655b0ad6eae535acf9423.svg";
export { ForwardRef as ReactComponent };